// @ts-nocheck
// Agent Portal (/cti2) — one section frame for My Dashboard.
//
// The dashboard stacks four panels that were each built separately and bring
// mismatched chrome: AgentCallStatsPanel has its own toolbar card and an
// <h2>, LeadsScreen an <h4> with bootstrap-ish spacing, and both
// VoicemailsPanel and DispositionFollowUpsPanel return bare fragments with no
// container at all. Stacked with only bottom padding between them, nothing
// read as a section boundary.
//
import React from 'react';
import { HAIRLINE } from '../team/teamUi';

export default function DashboardSection({
  id,
  eyebrow,
  title,
  subtitle,
  right,
  framed = true,
  bodyClassName = '',
  children,
}: any) {
  return (
    <section id={id} style={{ scrollMarginTop: 'var(--section-scroll-offset, 56px)' }}>
      <div className="mb-2.5 flex items-end justify-between gap-4">
        <div className="min-w-0">
          {eyebrow ? (
            <div className="mb-1 text-[10px] font-semibold uppercase tracking-[0.11em] text-muted-foreground">
              {eyebrow}
            </div>
          ) : null}
          <h2 className="truncate text-[15px] font-semibold tracking-tight text-foreground">{title}</h2>
          {subtitle ? <p className="mt-0.5 truncate text-[11px] text-muted-foreground">{subtitle}</p> : null}
        </div>
        {right ? <div className="shrink-0">{right}</div> : null}
      </div>

      <div
        className={`${framed ? `cti-kpi-card card-hover-raise rounded-2xl border ${HAIRLINE} bg-card p-3` : ''} ${bodyClassName}`.trim()}
      >
        {children}
      </div>
    </section>
  );
}
